import React from 'react';
import resolveIcon from '../utils/iconResolver';
import { formatValue } from '../utils/formatters';

const StatGridRenderer = ({ data, config }) => {
  if (!data || !config.metrics) return null;

  return (
    <div className="grid grid-cols-2 gap-3">
      {config.metrics.map((metric, index) => {
        const Icon = resolveIcon(metric.icon);
        const rawValue = data[metric.key];
        const formatted = formatValue(rawValue, metric.format || 'number');

        return (
          <div key={index} className="p-3 rounded-lg border">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs font-medium text-gray-600 mb-1">{metric.label}</p>
                <p className="text-lg font-bold text-gray-900">{formatted}</p>
              </div>
              {Icon && (
                <div className={`p-2 rounded-full ${metric.bgColor || 'bg-gray-100'}`}>
                  <Icon className={`w-5 h-5 ${metric.color || 'text-gray-600'}`} />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatGridRenderer;
